export const ERROR_CODES = {
  DISABLED_USER: 'USER_DISABLED',
  BLOCKED_USER: 'TOO_MANY_ATTEMPTS_TRY_LATER',
  RECAPTCHA_REQUIRED: 'RECAPTCHA_REQUIRED',
}
